// extracted by mini-css-extract-plugin
export var fullHeightState = "_52-7";
export var headerCell = "_52-1";
export var loadingStateCell = "_52-4";
export var rowWrapper = "_52-3";
export var standaloneTable = "_52-8";
export var standaloneTableWithBodyFill = "_52-9";
export var stateCell = "_52-5";
export var table = "_52-0";
export var tableBodyFiller = "_52-6";
export var white = "_52-2";